<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useStoreApp } from "@/stores/storeApp";
import { useCardDetails } from "~/components/card-details/use-card-details";
import Modal from "~/components/common/Modal.vue";
import ModalDeposit from "~/components/modals/ModalDeposit.vue";
import ModalEquipmentsUpgrade from "~/components/modals/ModalEquipmentsUpgrade.vue";
import ModalUnlockEquipment from "~/components/modals/ModalUnlockEquipment.vue";
import { useStoreUserV2 } from "~/stores/storeUserV2";
import ModalSwapMatic from "~/views/User/ModalSwapMatic.vue";
import ModalTransferToWallet from "~/views/User/ModalTransferToWallet.vue";
import ModalWithdraw from "~/views/User/ModalWithdraw.vue";
import ModalOnboarding from "./modals/ModalOnboarding.vue";
import ModalPack from "./modals/ModalPack.vue";

const { t } = useI18n();
const storeApp = useStoreApp();
const userStore = useStoreUserV2();
const cardDetails = useCardDetails();

function needMaticGotoMyAccount() {
  userStore.openProfileDrawer("default");
  storeApp.showNeedMatic = false;
}
</script>

<template>
  <Modal :show="storeApp.showNeedMatic" @closed="storeApp.showNeedMatic = false">
    <div class="flex flex-col items-center gap-6">
      <icon-clarity:warning-line class="h-8 w-8 text-orange-40" />
      <h1 class="text-2xl uppercase font-display">{{ t("modals.needMatic.title") }}</h1>
      <p class="flex flex-wrap max-w-[400px] whitespace-pre-wrap">
        {{ t("modals.needMatic.desc") }}
      </p>
      <button class="btn-primary" @click="needMaticGotoMyAccount">
        {{ t("modals.needMatic.linktomyaccount") }}
      </button>
    </div>
  </Modal>
  <Modal
    :show="storeApp.showListModal"
    @closed="storeApp.showListModal = false"
    :background="false"
    full-content
    :has-close-button="false"
  >
    <ModalList @closed="storeApp.showListModal = false" />
  </Modal>
  <CardDetails div v-if="cardDetails.showModal" is-modal />
  <ModalEquipmentsUpgrade
    v-if="storeApp.showEquipmentsUpgradeModal"
    v-model:show="storeApp.showEquipmentsUpgradeModal"
  />
  <ModalUnlockEquipment
    v-if="storeApp.showUnlockEquipmentModal"
    v-model:show="storeApp.showUnlockEquipmentModal"
  />
  <ModalDeposit
    v-if="storeApp.showDepositModal"
    v-model:show="storeApp.showDepositModal"
    @on-close="storeApp.showDepositModal = false"
  />
  <ModalSwapMatic
    v-if="storeApp.showSwapModal"
    v-model:show="storeApp.showSwapModal"
    @on-close="storeApp.showSwapModal = false"
  />

  <ModalTransferToWallet
    v-if="storeApp.showTransferModal"
    v-model:show="storeApp.showTransferModal"
    @on-close="storeApp.showTransferModal = false"
  />

  <ModalTransferToWallet
    v-if="storeApp.showMigrateUsdcToSmartWalletModal"
    v-model:show="storeApp.showMigrateUsdcToSmartWalletModal"
    :smartWalletMigration="true"
    @on-close="storeApp.showMigrateUsdcToSmartWalletModal = false"
  />

  <ModalWithdraw
    v-if="storeApp.showWithdrawModal"
    v-model:show="storeApp.showWithdrawModal"
    @on-close="storeApp.showWithdrawModal = false"
  />

  <ModalOnboarding
    v-if="storeApp.showOnboardingModal"
    @on-close="storeApp.showOnboardingModal = false"
  />

  <ModalRG2025 v-if="storeApp.showRG2025Modal" @on-close="storeApp.showRG2025Modal = false" />

  <ModalBid
    v-if="storeApp.showBidModal"
    :show="storeApp.showBidModal"
    @on-close="storeApp.showBidModal = false"
  />

  <ModalAuth
    v-if="storeApp.showAuthModal"
    :show="storeApp.showAuthModal"
    @on-close="storeApp.showAuthModal = false"
  />

  <ModalEmailVerificationRedirect
    v-if="storeApp.showRedirectToOldAuth"
    @on-close="storeApp.showRedirectToOldAuth = false"
  />

  <ModalRegistration
    v-if="storeApp.showRegistrationModal"
    @on-close="storeApp.showRegistrationModal = false"
  />

  <ModalPack
    v-if="storeApp.showPackModal"
    :show="storeApp.showPackModal"
    @on-close="storeApp.showPackModal = false"
  />

  <ModalMigrateToUsdc
    v-if="storeApp.showMigrateToUsdcModal"
    :show="storeApp.showMigrateToUsdcModal"
    @on-close="storeApp.showMigrateToUsdcModal = false"
  />

  <ModalMigrateToSmartWallet
    v-if="storeApp.showMigrateToSmartWalletModal"
    :show="storeApp.showMigrateToSmartWalletModal"
    @on-close="storeApp.showMigrateToSmartWalletModal = false"
  />

  <ProfileDrawer />
  <NotificationDrawer />
</template>
